/**
 * EnergyConnect.WebApi | v1
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const AdvancedEstimationInterval = {
    NotSpecified: 'NotSpecified',
    Hour: 'Hour',
    Quarter: 'Quarter',
} as const;
export type AdvancedEstimationInterval = typeof AdvancedEstimationInterval[keyof typeof AdvancedEstimationInterval];

